import { render, staticRenderFns } from "./materialScience_span.vue?vue&type=template&id=4e43da29&scoped=true"
import script from "./materialScience_span.vue?vue&type=script&lang=js"
export * from "./materialScience_span.vue?vue&type=script&lang=js"
import style0 from "./materialScience_span.vue?vue&type=style&index=0&id=4e43da29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43da29",
  null
  
)

export default component.exports